// src/routes/AppRoutes.jsx
import { BrowserRouter as Router, Routes, Route,Navigate  } from 'react-router-dom';
import AboutUs from '../components/aboutUs/aboutUs';
import Media from '../components/media/media';
import Main from '../components/main/main';
import Contact from '../components/contactUs/contactUs';
import ScrollToTop from '../Utils/ScrollToTop';
import { Provider } from 'react-redux';
import AppStore from '../Utils/Appstore';
import Solutions from '../components/solutions/solutions';
import UTMContact from '../components/utmContact/utmContact';
const AppRoutes = () => (
  <Router>
    <ScrollToTop />
    <Provider store={AppStore}>
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Main />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/media" element={<Media />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/utm-contact" element={<UTMContact />} />
        
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
      </Provider>
  </Router>
);

export default AppRoutes;
